/* @ngInject */
function uniqueSlug($q) {
  return {
    restrict: "A",
    require: "ngModel",
    scope: {
      uniqueSlug: "=",
    },
    link: function (scope, element, attrs, ctrl) {
      const organization = scope.uniqueSlug;

      ctrl.$asyncValidators.uniqueSlug = function (modelValue, viewValue) {
        if (ctrl.$isEmpty(modelValue)) return $q.when(); // Válido si esta vacío

        const def = $q.defer();
        if (!organization.name) {
          def.resolve();
        } else {
          organization.uniqueSlug().then(function (response) {
            if (response.data) def.resolve();
            else def.reject();
          });
        }

        return def.promise;
      };
    },
  };
}

export default uniqueSlug;
